<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="fHeight"
    viewBox="0 0 40.572 41.447">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_11564" data-name="Rectangle 11564" :width="width" :height="height" :fill="themeColor" />
      </clipPath>
    </defs>
    <g id="Group_27763" data-name="Group 27763" clip-path="url(#clip-path)">
      <path id="Path_86979" data-name="Path 86979"
        :class="isInfinite ? 'animated-infinite delay-1' : 'animated-path delay-1'"
        d="M0,10.6C5.959,9.649,9.635,6.226,10.871,0c1.239,6.21,4.866,9.658,10.866,10.608-5.965.95-9.6,4.375-10.849,10.557C9.646,15.014,6.032,11.51,0,10.6"
        transform="translate(0 0)" :fill="themeColor" />
      <path id="Path_86980" data-name="Path 86980"
        :class="isInfinite ? 'animated-infinite delay-2' : 'animated-path delay-2'"
        d="M30.137,27.088a9.2,9.2,0,0,0-7.575-7.869,9.219,9.219,0,0,0,7.572-7.842c.817,4.326,3.322,6.89,7.788,7.862-4.456.963-6.972,3.521-7.785,7.849"
        transform="translate(2.65 1.336)" :fill="themeColor" />
      <path id="Path_86981" data-name="Path 86981"
        :class="isInfinite ? 'animated-infinite delay-3' : 'animated-path delay-3'"
        d="M7.607,31.943a7.988,7.988,0,0,0,6.224-6.52,7.9,7.9,0,0,0,6.554,6.54,7.858,7.858,0,0,0-6.54,6.5,7.987,7.987,0,0,0-6.238-6.518"
        transform="translate(0.893 2.986)" :fill="themeColor" />
    </g>
  </svg>

</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    fHeight: {
      type: String,
      required: false,
      default: '29px',
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '50px',
    },
    isPrimeColor: {
      type: Boolean,
      required: false,
      default: false,
    },
    isInfinite: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
    themeColor() {
      return this.chatThemeSettings.isGradient && !this.isPrimeColor ? '#fff' : this.themePrimaryColor;
    },
  },
}
</script>

<style>
.animated-path {
  opacity: 0;
  animation: fadeIn 1s ease forwards;
}

.animated-infinite {
  opacity: 0;
  animation: fadeIn 1s ease forwards, infiniteAnimation 2s ease-in-out infinite;
}

@keyframes infiniteAnimation {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

.delay-1 {
  animation-delay: 0.3s;
}

.delay-2 {
  animation-delay: 0.9s;
}

.delay-3 {
  animation-delay: 1.5s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
